export default __webpack_public_path__ + "static/media/hp-icon.6b5b8f04.png";